import { render } from "./PaceOfPlay.vue?vue&type=template&id=503fbef3&scoped=true"
import script from "./PaceOfPlay.vue?vue&type=script&lang=js"
export * from "./PaceOfPlay.vue?vue&type=script&lang=js"

import "./PaceOfPlay.vue?vue&type=style&index=0&id=503fbef3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503fbef3"]])

export default __exports__